import React from 'react';
import { useLocation } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { useNumberFormat, FORMAT_OPTIONS } from '../../context/NumberFormatContext';
import { cn } from '../../lib/utils';

const pageTitles = {
  '/dashboard':       'Executive Dashboard',
  '/aop':             'Annual Operating Plan',
  '/actuals':         'Actual Financials',
  '/variance':        'Variance Analysis',
  '/channels':        'Channel Performance',
  '/health':          'Business Health Radar',
  '/simulator':       'Decision Simulator',
  '/working-capital': 'Working Capital',
  '/settings':        'Settings',
};

export const Topbar = ({ sidebarCollapsed }) => {
  const location  = useLocation();
  const pageTitle = pageTitles[location.pathname] || 'Dashboard';
  const { format, setFormat } = useNumberFormat();
  const currentFmt = FORMAT_OPTIONS.find(f => f.key === format);

  return (
    <header
      className="glass-header sticky top-0 z-30 h-12 flex items-center justify-between px-4"
      style={{ marginLeft: sidebarCollapsed ? '60px' : '220px' }}
      data-testid="topbar"
    >
      <div className="flex items-center gap-4">
        <h1 className="font-heading text-xl font-semibold text-slate-900">
          {pageTitle}
        </h1>
      </div>

      <div className="flex items-center gap-2">

        {/* Number format toggle */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              size="sm"
              className="gap-1.5 font-semibold text-primary-700 border-primary-200 bg-primary-50 hover:bg-primary-100"
              title="Switch number display format"
            >
              ₹ {currentFmt?.label}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-52">
            <DropdownMenuLabel className="text-xs text-slate-500">Display numbers as</DropdownMenuLabel>
            <DropdownMenuSeparator />
            {FORMAT_OPTIONS.map(opt => (
              <DropdownMenuItem
                key={opt.key}
                onClick={() => setFormat(opt.key)}
                className={cn(
                  'flex items-center justify-between cursor-pointer',
                  format === opt.key && 'bg-primary-50 text-primary-700 font-semibold'
                )}
              >
                <span>{opt.description}</span>
                {format === opt.key && <span className="text-primary-600 text-xs">✓</span>}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>

        {/* Notifications — placeholder for future */}
        <Button variant="ghost" size="icon" className="relative text-slate-500" data-testid="notifications-button">
          <Bell className="w-5 h-5" />
        </Button>

      </div>
    </header>
  );
};

export default Topbar;
